import frFR from './fr-fr'

export default {
  'fr-FR': frFR,
  'fr': frFR
}
